<template>
  <v-row no-gutters>
    <v-col cols="12" sm="12" class="meeting-action-buttons">
      <v-row no-gutters>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
          align="right"
          justify="end"
          id="agenda"
          style="background-color: transparent"
        >
          <chat-for-meeting
            v-if="meetingObject.id"
            :attendeesList="attendeesList"
            :selectedMeeting="meetingObject"
          ></chat-for-meeting>
          <agenda-topic-selector
            v-if="updateMeetingPermission"
            :selectedMeeting="meetingObject"
            @onTopicSelection="handleTopicSelection"
            @openAgendaDialog="openAgendaDialog"
            @removeTopic="removeUnSavedTopics"
          ></agenda-topic-selector>

          <v-tooltip bottom v-if="updateMeetingPermission && isRemindAlert">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                @click.stop="votingAlertDialog"
                :disabled="isMeetingModified"
              >
                <v-icon size="16" class="mr-1">mdi-email-outline</v-icon>
                {{ $t("agenda.lblRemindVotingInWriting") }}
              </a-btn>
            </template>
            <span>{{ $t("agenda.remindVotingInWritingTooltip") }}</span>
          </v-tooltip>

          <v-tooltip bottom v-if="downloadConvocationPermission">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                @click.stop="remindAlertConvocation"
                :disabled="isMeetingModified"
              >
                <v-icon size="16" class="mr-1">mdi-email-outline</v-icon>
                {{ $t("agenda.convoHeading") }}
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipConvoHeading") }}</span>
          </v-tooltip>

          <v-tooltip bottom v-if="viewMeetingTimerPermission">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                @click.stop="openMeetingTimer()"
                :disabled="isMeetingModified"
              >
                <v-icon size="16" class="mr-1">mdi-open-in-new</v-icon
                >{{ $t("agenda.btnMeetingTimer") }}</a-btn
              >
            </template>
            <span>{{ $t("agenda.tipMeetingTimer") }}</span>
          </v-tooltip>
          <v-tooltip bottom v-if="openMeetingDocumentPermission">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                @click.stop="OpenAllDocuments()"
                ><v-icon size="16" class="mr-1">mdi-open-in-new</v-icon>
                {{ $t("agenda.OpenAllDocs") }}
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipOpenAllDocs") }}</span>
          </v-tooltip>

          <v-tooltip bottom v-if="openMeetingDocumentPermission">
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mx-1 my-1"
                color="primaryDark"
                v-bind="attrs"
                v-on="on"
                @click.stop="SaveAllDocuments()"
                ><v-icon size="16" class="mr-1">mdi-download-multiple</v-icon>
                {{ $t("agenda.SaveAllDocs") }}
              </a-btn>
            </template>
            <span>{{ $t("agenda.tipSaveAllDocs") }}</span>
          </v-tooltip>
          <email-selection-dialog
            v-if="
              (updateMeetingPermission || downloadConvocationPermission) &&
              emailAlertSelectionDialog
            "
            v-model="emailAlertSelectionDialog"
            :emailTemplate="emailTemplate"
            :defaulter="remindAttendees"
            :suggestedList="suggestedAttendees"
            @send="onEmailSend"
            :heading="alertHeading"
            :isImageSupport="section === 'ConvocationMail'"
            :section="section"
            :meetingPurpose="meetingPurpose"
            :step="1"
          ></email-selection-dialog>
          <email-alert-notification
            v-if="
              (updateMeetingPermission || downloadConvocationPermission) &&
              dialogRemind
            "
            v-model="dialogRemind"
            :emailTemplate="emailTemplate"
            :defaulter="remindAttendees"
            :suggestedList="suggestedAttendees"
            @send="onEmailSend"
            type="remind"
            :heading="alertHeading"
            :isImageSupport="section === 'ConvocationMail'"
            :section="section"
            :meetingPurpose="meetingPurpose"
          ></email-alert-notification>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" sm="12" class="mt-6">
      <v-card
        :class="categorizedTopics.length ? 'boxShadow-none mx-auto' : 'mx-auto'"
        :color="categorizedTopics.length ? 'transparent' : 'secondary'"
      >
        <v-card-text :class="categorizedTopics.length ? 'padding-0' : ''">
          <draggable
            v-model="data.topicCategories"
            group="topicCategories"
            @change="onCatOrderChanged($event)"
            :disabled="true"
            class="draggable-panels"
            style="width: 100%"
          >
            <span v-if="!categorizedTopics.length">
              <div
                v-if="updateMeetingPermission"
                :key="render"
                @click="openAgenda($event)"
                v-html="
                  $t('agenda.msgNoSelectedTopics', {
                    manageAgenda: $t('agenda.lblManageAgenda'),
                  })
                "
              ></div>
              <div v-else>{{ $t("agenda.msgIfNoPemissionNoTopics") }}</div>
            </span>
            <v-card
              class="element"
              v-for="(category, parentIndex) in categorizedTopics"
              :key="`${category.id}_${parentIndex}`"
            >
              <div
                v-if="category.topics.length > 0"
                style="
                  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
                    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
                    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
                "
              >
                <v-toolbar
                  color="primary"
                  dense
                  flat
                  elevation="0"
                  dark
                  class="panel-header"
                  @click="onExpandClick(category.id)"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-toolbar-title class="h4" v-bind="attrs" v-on="on">
                        {{ category.name }}
                      </v-toolbar-title>
                    </template>
                    <span>{{ $t("agenda.hTopicCategory") }}</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        dark
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="onExpandClick(category.id)"
                        class="mr-1"
                      >
                        <v-icon v-if="isPanelExpand(category.id)"
                          >mdi-chevron-up
                        </v-icon>
                        <v-icon v-else>mdi-chevron-down </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="isPanelExpand(category.id)">{{
                      $t("lblCollapse")
                    }}</span>
                    <span v-else>{{ $t("lblExpand") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="updateMeetingPermission">
                    <template v-slot:activator="{ on, attrs }">
                      <a-btn
                        v-if="updateMeetingPermission"
                        v-bind="attrs"
                        v-on="on"
                        class="arrow-up-thick-left ml-6"
                        x-small
                        color="primaryDark"
                        width="24"
                        min-width="24"
                        :style="
                          parentIndex === 0
                            ? ' background-color: #cccccc !important; opacity: 0.5 !important;'
                            : ''
                        "
                        :disabled="parentIndex === 0"
                        @click.stop="
                          changeCategoryOrderUpDown(true, category.id)
                        "
                      >
                        <v-icon size="16" color="#fff">
                          mdi-arrow-up-thick</v-icon
                        >
                      </a-btn>
                    </template>
                    <span>{{ $t("lblMoveUp") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="updateMeetingPermission">
                    <template v-slot:activator="{ on, attrs }">
                      <a-btn
                        v-if="updateMeetingPermission"
                        v-bind="attrs"
                        v-on="on"
                        class="arrow-down-thick-right ml-1"
                        x-small
                        color="primaryDark"
                        width="24"
                        min-width="24"
                        :style="
                          parentIndex == categorizedTopics.length - 1
                            ? 'background-color: #cccccc !important; opacity: 0.5 !important;'
                            : ''
                        "
                        @click.stop="
                          changeCategoryOrderUpDown(false, category.id)
                        "
                        :disabled="parentIndex == categorizedTopics.length - 1"
                      >
                        <v-icon size="16" color="#fff">
                          mdi-arrow-down-thick</v-icon
                        >
                      </a-btn>
                    </template>
                    <span>{{ $t("lblMoveDown") }}</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text v-show="isPanelExpand(category.id)">
                  <draggable
                    v-model="category.topics"
                    :group="category.name"
                    @change="onChanged($event, category)"
                    :disabled="true"
                    class="draggable-panel-content"
                    style="width: 100%"
                  >
                    <v-row
                      no-gutters
                      v-for="(item, index) in category.topics"
                      :key="`${item.Id}_${index}`"
                      :item="item"
                      :headers="topicHeads"
                    >
                      <v-col cols="12" sm="12" md="12">
                        <v-row no-gutters>
                          <v-col cols="12" sm="5" md="5">
                            <v-row no-gutters>
                              <v-col cols="12" sm="7">
                                <div v-if="item.agenda" class="pt-1 mr-2">
                                  <h4>
                                    <v-tooltip bottom v-if="item.agenda">
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <span v-bind="attrs" v-on="on">
                                          {{ item.agenda.agendaName }}
                                        </span>
                                      </template>
                                      <span>{{ $t("agenda.tipAgenda") }}</span>
                                    </v-tooltip>
                                  </h4>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="5">
                                <div class="text-left">
                                  <colored-chip-template
                                    v-if="item.agenda"
                                    :textValue="item.agenda.priority"
                                    chipColumn="priority"
                                  ></colored-chip-template>
                                  <a-chip small outlined class="low mr-2 ml-2">
                                    {{ item.timeInMinutes }} {{ $t("Minutes") }}
                                  </a-chip>
                                  <v-menu
                                    v-if="updateMeetingPermission"
                                    :ref="`menuRef_${parentIndex}_${index}`"
                                    bottom
                                    offset-y
                                    right
                                    :close-on-content-click="false"
                                    max-width="120"
                                    :nudge-bottom="2"
                                    content-class="disable-box-shadow"
                                    :close-on-click="false"
                                    @input="updateTimeEvent"
                                  >
                                    <template
                                      v-slot:activator="{ on: menu, attrs }"
                                    >
                                      <v-tooltip
                                        v-if="updateMeetingPermission"
                                        bottom
                                        :disabled="disableUpdateTimeTip"
                                      >
                                        <template
                                          v-slot:activator="{ on: tooltip }"
                                        >
                                          <a-btn
                                            x-small
                                            color="secondary"
                                            width="24"
                                            min-width="24"
                                            v-bind="attrs"
                                            v-on="{ ...tooltip, ...menu }"
                                          >
                                            <v-icon
                                              size="16"
                                              color="neutralGray1"
                                            >
                                              mdi-pencil</v-icon
                                            >
                                          </a-btn>
                                        </template>
                                        <span>
                                          {{
                                            updateMeetingPermission
                                              ? $t("agenda.tipUpdateTime")
                                              : $t("agenda.tipScheduleTime")
                                          }}</span
                                        >
                                      </v-tooltip>
                                    </template>
                                    <div v-if="updateMeetingPermission">
                                      <v-row no-gutters>
                                        <v-text-field
                                          class="edit-time-field"
                                          v-if="showTimeTextField"
                                          :ref="`timeRef_${parentIndex}_${index}`"
                                          :value="item.timeInMinutes"
                                          :suffix="$t('Minutes')"
                                          autofocus
                                          filled
                                          solo
                                          dense
                                          :disabled="!updateMeetingPermission"
                                          type="Number"
                                          :min="1"
                                          :max="9999"
                                          @keydown="filterKey"
                                          :maxlength="timeDigitTextLimit"
                                          pattern="/^-?\d+\.?\d*$/"
                                          onKeyPress="if(this.value.length==maxLength) { return false; }"
                                          @blur="
                                            onSaveTime(
                                              `menuRef_${parentIndex}_${index}`,
                                              `timeRef_${parentIndex}_${index}`,
                                              item
                                            )
                                          "
                                        >
                                        </v-text-field>
                                      </v-row>
                                      <v-row no-gutters v-if="false">
                                        <v-col
                                          cols="12"
                                          sm="12"
                                          class="text-right mt-2"
                                        >
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <a-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-2"
                                                x-small
                                                color="primaryDark"
                                                width="24"
                                                min-width="24"
                                                @click.prevent="
                                                  onSaveTime(
                                                    `menuRef_${parentIndex}_${index}`,
                                                    `timeRef_${parentIndex}_${index}`,
                                                    item
                                                  )
                                                "
                                              >
                                                <v-icon
                                                  size="16"
                                                  color="#ffffff"
                                                >
                                                  mdi-check</v-icon
                                                >
                                              </a-btn>
                                            </template>
                                            <span>{{ $t("btnSave") }}</span>
                                          </v-tooltip>
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <a-btn
                                                v-bind="attrs"
                                                v-on="on"
                                                class="ml-2"
                                                x-small
                                                color="secondary"
                                                width="24"
                                                min-width="24"
                                                @click="
                                                  onTimeMenuEnter(
                                                    `menuRef_${parentIndex}_${index}`
                                                  )
                                                "
                                              >
                                                <v-icon
                                                  size="16"
                                                  color="neutralGray1"
                                                >
                                                  mdi-close</v-icon
                                                >
                                              </a-btn>
                                            </template>
                                            <span>{{ $t("btnClose") }}</span>
                                          </v-tooltip>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </v-menu>
                                </div>
                              </v-col>
                            </v-row>
                            <v-row no-gutters class="pt-3">
                              <span v-if="item.agenda" style="width: 100%">
                                <h2>
                                  <ul>
                                    <v-tooltip bottom v-if="item.agenda">
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <li
                                          v-bind="attrs"
                                          v-on="on"
                                          class="topic-list-style"
                                          :style="
                                            agendanumbering == '' ||
                                            agendanumbering == 'no_numbering'
                                              ? ''
                                              : 'list-style-type: none'
                                          "
                                        >
                                          {{
                                            agendanumbering ==
                                            "numbering_for_meeting"
                                              ? `${item.meetindNumbering}.`
                                              : agendanumbering ==
                                                "numbering_for_category"
                                              ? `${index + 1}.`
                                              : ""
                                          }}
                                          {{ item.topicName }}
                                        </li>
                                      </template>
                                      <span>{{ $t("topic") }}</span>
                                    </v-tooltip>
                                  </ul>
                                </h2>
                              </span>
                            </v-row>
                            <v-row>
                              <v-col cols="12">
                                <topic-memo
                                  :value="item.memoDescription"
                                  :disabled="updateMeetingPermission"
                                  @input="onMemoDescriptionUpdate($event, item)"
                                  :abstractRows="abstractRows"
                                ></topic-memo>
                              </v-col>
                            </v-row>
                          </v-col>

                          <v-col cols="12" sm="3">
                            <v-row no-gutters>
                              <v-col cols="12" sm="12">
                                <v-list
                                  dense
                                  class="mb-0"
                                  style="margin-top: -15px !important"
                                >
                                  <div
                                    v-for="pic in item.peopleInCharge"
                                    :key="pic.email"
                                  >
                                    <meeting-presentor
                                      :person="getPresenter(pic)"
                                    ></meeting-presentor>
                                  </div>
                                </v-list>
                              </v-col>
                              <v-col cols="12" sm="12" class="ml-4">
                                <presentor-dropdown-list
                                  v-if="updateMeetingPermission"
                                  :items="presenterList"
                                  :selected-item="item"
                                  @onSelection="onChangePresentor"
                                  @remove="onRemoveInterimPresentor"
                                ></presentor-dropdown-list>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12" sm="4">
                            <v-row no-gutters>
                              <v-col cols="12" sm="11">
                                <div
                                  @drop.prevent="
                                    updateMeetingPermission
                                      ? addDropFile($event, item)
                                      : ''
                                  "
                                  @dragover.prevent
                                >
                                  <v-row
                                    no-gutters
                                    v-if="updateMeetingPermission"
                                  >
                                    <div class="parentInput mb-2" v-cloak>
                                      <form :ref="'fileInput' + item.Id">
                                        <input
                                          v-show="false"
                                          type="file"
                                          :id="item.Id"
                                          class="input"
                                          @change="
                                            filesChange(
                                              $event.target.files,
                                              item
                                            )
                                          "
                                        />
                                      </form>
                                      <label :for="item.Id">
                                        <v-icon
                                          class="mr-1"
                                          color="neutralGray1"
                                          >mdi-attachment</v-icon
                                        >
                                        {{ $t("agenda.AttachFile") }}
                                      </label>
                                    </div>
                                  </v-row>
                                  <!-- <v-row no-gutters> -->
                                  <draggable
                                    v-model="item.documents"
                                    :group="`${item.Id}_topicDocuments`"
                                    :disabled="!updateMeetingPermission"
                                    @change="onDocOrderChanged($event, item)"
                                    class="draggable-panel-content w-100"
                                    handle=".drag-handle"
                                  >
                                    <div
                                      v-for="doc in item.documents"
                                      :key="doc.documentId"
                                      :class="[
                                        openMeetingDocumentPermission
                                          ? 'downloadLink'
                                          : '',
                                        countActiveDocuments > 0 &&
                                        activeDocumentViews[doc.documentId] ==
                                          true
                                          ? 'active'
                                          : '',
                                        doc.formData ? 'cursor-default' : '',
                                      ]"
                                    >
                                      <v-row no-gutters>
                                        <v-col cols="12" sm="10" md="10">
                                          <v-tooltip
                                            bottom
                                            v-if="openMeetingDocumentPermission"
                                          >
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <span
                                                class="body-m primary--text"
                                                @click="
                                                  !doc.formData
                                                    ? documentDownload(doc)
                                                    : ''
                                                "
                                                v-bind="attrs"
                                                v-on="on"
                                                ><v-icon
                                                  size="18"
                                                  left
                                                  color="neutralGray1"
                                                  >mdi-file-document</v-icon
                                                >
                                                <a-chip
                                                  x-small
                                                  class="pt-0 pl-1 pr-1"
                                                  color="primaryDark"
                                                  dark
                                                  label
                                                  style="line-height: 10px"
                                                  v-if="
                                                    !activeDocumentViews[
                                                      doc.documentId
                                                    ] ||
                                                    activeDocumentViews[
                                                      doc.documentId
                                                    ] == false
                                                  "
                                                  >{{ $t("lblNew") }}</a-chip
                                                >
                                                {{ doc.fileName }}
                                              </span>
                                            </template>
                                            <p class="ma-0">
                                              {{ $t("lblFileName") }} :
                                              {{ doc.fileName }}
                                            </p>
                                            <p class="ma-0" v-if="doc.size">
                                              {{ $t("lblFileSize") }} :
                                              {{ formatBytes(doc.size) }}
                                            </p>

                                            <p
                                              class="ma-0"
                                              v-if="doc.lastModified"
                                            >
                                              {{ $t("lblLastModifiedTime") }} :
                                              {{
                                                convertIntlDateFormat(
                                                  doc.lastModified
                                                )
                                              }}
                                            </p>
                                          </v-tooltip>
                                          <span v-else
                                            ><v-icon
                                              size="18"
                                              left
                                              color="neutralGray1"
                                              >mdi-file-document</v-icon
                                            >{{ doc.fileName }}</span
                                          >
                                          <v-tooltip bottom v-if="doc.formData">
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-btn
                                                icon
                                                x-small
                                                v-bind="attrs"
                                                v-on="on"
                                                v-if="doc.formData"
                                              >
                                                <v-icon
                                                  >mdi-alert-circle-outline</v-icon
                                                >
                                              </v-btn>
                                            </template>
                                            <span>{{
                                              $t("agenda.unSavedDocument")
                                            }}</span>
                                          </v-tooltip>
                                        </v-col>
                                        <v-col cols="12" sm="2" md="2">
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-btn
                                                v-if="updateMeetingPermission"
                                                x-small
                                                color="neutralGray1"
                                                icon
                                                right
                                                v-bind="attrs"
                                                v-on="on"
                                                class="drag-handle"
                                                style="cursor: move"
                                                ><v-icon size="18">
                                                  mdi-drag</v-icon
                                                ></v-btn
                                              >
                                            </template>
                                            <span>{{
                                              $t("people.tipMoveButton")
                                            }}</span>
                                          </v-tooltip>
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-btn
                                                v-if="
                                                  openMeetingDocumentPermission
                                                "
                                                x-small
                                                icon
                                                color="neutralGray1"
                                                right
                                                @click="saveDocument(doc)"
                                                v-bind="attrs"
                                                v-on="on"
                                                :disabled="
                                                  doc.formData ? true : false
                                                "
                                                ><v-icon size="18">
                                                  mdi-download</v-icon
                                                ></v-btn
                                              >
                                            </template>
                                            <span>{{
                                              $t("agenda.tipSaveDoc")
                                            }}</span>
                                          </v-tooltip>
                                          <v-tooltip bottom>
                                            <template
                                              v-slot:activator="{ on, attrs }"
                                            >
                                              <v-btn
                                                v-if="updateMeetingPermission"
                                                x-small
                                                color="neutralGray1"
                                                icon
                                                right
                                                @click="
                                                  deleteDocument(doc, item)
                                                "
                                                v-bind="attrs"
                                                v-on="on"
                                                ><v-icon size="18">
                                                  mdi-delete</v-icon
                                                ></v-btn
                                              >
                                            </template>
                                            <span>{{
                                              $t("agenda.tipDeleteDoc")
                                            }}</span>
                                          </v-tooltip>
                                        </v-col>
                                      </v-row>
                                    </div>
                                  </draggable>
                                </div>
                              </v-col>
                              <v-col cols="12" sm="1" md="1">
                                <div class="text-right">
                                  <div>
                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <a-btn
                                          v-if="updateMeetingPermission"
                                          v-bind="attrs"
                                          v-on="on"
                                          class="arrow-up-thick"
                                          x-small
                                          color="primaryDark"
                                          width="24"
                                          min-width="24"
                                          :disabled="index === 0"
                                          @click="
                                            topicMoveUp(
                                              item,
                                              parentIndex,
                                              index
                                            )
                                          "
                                        >
                                          <v-icon size="16" color="#fff">
                                            mdi-arrow-up-thick</v-icon
                                          >
                                        </a-btn>
                                      </template>
                                      <span>{{ $t("lblMoveUp") }}</span>
                                    </v-tooltip>
                                  </div>
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <a-btn
                                        v-if="updateMeetingPermission"
                                        v-bind="attrs"
                                        v-on="on"
                                        class="arrow-down-thick"
                                        x-small
                                        color="primaryDark"
                                        width="24"
                                        min-width="24"
                                        :disabled="
                                          index === category.topics.length - 1
                                        "
                                        @click="
                                          topicMovedown(
                                            item,
                                            parentIndex,
                                            index
                                          )
                                        "
                                      >
                                        <v-icon size="16" color="#fff">
                                          mdi-arrow-down-thick</v-icon
                                        >
                                      </a-btn>
                                    </template>
                                    <span>{{ $t("lblMoveDown") }}</span>
                                  </v-tooltip>
                                
                                  <topic-move-meeting-list
                                    v-if="updateMeetingPermission"
                                    :selectedMeeting="meetingObject"
                                    :topic="item"
                                    @onConfirmMove="removeTopic(item, true)"
                                    :isMeetingModified="isMeetingModified"
                                  ></topic-move-meeting-list>
                                  <topic-tags
                                    v-if="viewTagPermission"
                                    :topic="item"
                                    :index="index"
                                    :currentMeeting="meetingObject"
                                    @saveTagMsg="showSaveTagMsg"
                                    @topicWithSavedTag="topicWithSavedTag"
                                  >
                                  </topic-tags>
                                </div>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row
                          no-gutters
                          v-if="String(category.isapprovalrequired) === 'true'"
                        >
                          <approval-control
                            v-if="item.agenda && approvalStatus"
                            v-model="item.approval"
                            :isAttendee="isAttendee"
                            :agenda-name="item.agenda.agendaName"
                            :topic-name="item.topicName"
                            :topic-data="item"
                            :meetingObj="meetingObject"
                            :voteData="getVote(item.Id)"
                            :topicId="item.Id"
                            @onApprovalChange="onApprovalChange(item)"
                            @onApprovalSettingChange="
                              onApprovalSettingChange(item)
                            "
                            :isMeetingModified="isMeetingModified"
                          ></approval-control>
                        </v-row>
                        <v-row class="mt-0" v-if="topicFeedbackPermission">
                          <v-col cols="6">
                            <topic-feedback
                              v-if="meetingObject.meeting_feedbacks"
                              :selectedMeeting="meetingObject"
                              :topic="item"
                            ></topic-feedback>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-row v-if="updateMeetingPermission">
                        <v-col cols="12" sm="12" md="12">
                            <v-card
                            class="d-flex flex-row-reverse"
                            flat
                            tile
                            v-if="updateMeetingPermission"
                          >
                            <div class="mt-2" >
                                <v-tooltip bottom>
                                  <template
                                    v-slot:activator="{ on, attrs }"
                                  >
                                    <a-btn
                                      x-small
                                      color="primaryDark"
                                      width="24"
                                      min-width="24"
                                      v-on="on"
                                      v-bind="attrs"
                                      @click.stop="
                                        confirmTopicRemoval(item)
                                      "
                                    >
                                      <v-icon size="16" color="#fff">
                                        mdi-delete</v-icon
                                      >
                                    </a-btn>
                                  </template>
                                  <span>{{
                                    $t("agenda.tipRemoveTopic")
                                  }}</span>
                                </v-tooltip>
                              </div>
                          </v-card>
                        </v-col>
                      </v-row>
                      
                      <v-col cols="12" sm="12" md="12">
                        <v-divider
                          v-if="index < category.topics.length - 1"
                          class="mt-4 mb-4"
                        ></v-divider>
                      </v-col>
                    </v-row>
                  </draggable>
                </v-card-text>
              </div>
            </v-card>
          </draggable>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      sm="12"
      class="mt-6"
      v-if="
        updateMeetingPermission ||
        generateTranscriptionPermission ||
        viewMomCommentPermission ||
        sendMomCommentNotificationPermission ||
        momESignatureManagement
      "
    >
      <v-card class="element">
        <v-toolbar
          color="primary"
          dense
          flat
          elevation="0"
          dark
          class="panel-header"
          @click="onExpandMOMPanelClick(0)"
        >
          <v-toolbar-title class="h4">
            {{ $t("agenda.lblMOMprocessing") }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="mr-1"
                @click.stop="onExpandMOMPanelClick(0)"
              >
                <v-icon v-if="isMOMAttendeesPanelOpen(0)"
                  >mdi-chevron-up
                </v-icon>
                <v-icon v-else>mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <span v-if="isMOMAttendeesPanelOpen(0)">{{
              $t("lblCollapse")
            }}</span>
            <span v-else>{{ $t("lblExpand") }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text v-show="isMOMAttendeesPanelOpen(0)">
          <mom-generate
            :categorizedTopics="categorizedTopics"
            :meetingObject="meetingObject"
          ></mom-generate>
          <v-row
            no-gutters
            v-if="
              (updateMeetingPermission || generateTranscriptionPermission) &&
              (viewMomCommentPermission ||
                sendMomCommentNotificationPermission ||
                momESignatureManagement)
            "
          >
            <v-divider class="mt-4"></v-divider>
          </v-row>
          <mom-annotation :meetingObject="meetingObject"></mom-annotation>
          <v-row
            no-gutters
            v-if="
              (viewMomCommentPermission ||
                sendMomCommentNotificationPermission) &&
              momESignatureManagement &&
              isParticipants
            "
          >
            <v-divider class="mt-4"></v-divider>
          </v-row>
          <MOMSignature
            v-if="momESignatureManagement"
            :meetingId="this.meetingObject.id"
            :meetingTypeId="getMeetingTypeId"
            :attendeesList="attendeesList"
            :meetingObject="meetingObject"
          ></MOMSignature>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" class="mt-6">
      <v-card class="element">
        <v-toolbar
          color="primary"
          dense
          flat
          elevation="0"
          dark
          class="panel-header"
          @click="onExpandMOMPanelClick(1)"
        >
          <v-toolbar-title class="h4">
            {{ $t("agenda.lblMOMFinalize") }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="mr-1"
                @click.stop="onExpandMOMPanelClick(1)"
              >
                <v-icon v-if="isMOMAttendeesPanelOpen(1)"
                  >mdi-chevron-up
                </v-icon>
                <v-icon v-else>mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <span v-if="isMOMAttendeesPanelOpen(1)">{{
              $t("lblCollapse")
            }}</span>
            <span v-else>{{ $t("lblExpand") }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text v-show="isMOMAttendeesPanelOpen(1)">
          <v-row v-if="updateMeetingPermission">
            <v-col cols="12" sm="5">
              <form ref="momInputUpload">
                <div
                  v-cloak
                  @drop.prevent="addDropMeetingMinutesFile($event)"
                  @dragover.prevent
                  class="parentInput"
                >
                  <input
                    v-show="false"
                    type="file"
                    id="momDocument"
                    class="input"
                    @change="meetingMinutesChanged($event.target.files)"
                  />
                  <label for="momDocument">
                    <v-icon class="mr-1" color="neutralGray1"
                      >mdi-attachment</v-icon
                    >
                    {{ $t("agenda.AttachMOMFile") }}
                  </label>
                </div>
              </form>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12">
              <v-list dense v-if="momDocuments.length > 0" class="file-list">
                <v-list-item
                  dense
                  v-for="(file, index) in momDocuments"
                  :key="index"
                  link
                  class="pt-0 pb-0"
                  :class="[file.formData ? 'cursor-default' : '']"
                >
                  <v-list-item-avatar
                    @click="
                      openMeetingDocumentPermission
                        ? documentDownload(file)
                        : ''
                    "
                  >
                    <v-icon class="mdi-36px" color="neutralGray1"
                      >mdi-file-document</v-icon
                    >
                  </v-list-item-avatar>
                  <v-list-item-content
                    @click="
                      openMeetingDocumentPermission
                        ? documentDownload(file)
                        : ''
                    "
                  >
                    <v-list-item-title
                      v-if="openMeetingDocumentPermission && !file.formData"
                      :class="[
                        openMeetingDocumentPermission ? 'downloadLink' : '',
                        countActiveDocuments > 0 &&
                        activeDocumentViews[file.documentId] == true
                          ? 'active'
                          : '',
                        'label-m',
                      ]"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div v-bind="attrs" v-on="on" style="display: inline">
                            <a-chip
                              x-small
                              class="pt-0 pl-1 pr-1"
                              color="primaryDark"
                              dark
                              label
                              style="line-height: 10px"
                              v-if="
                                !activeDocumentViews[file.documentId] ||
                                activeDocumentViews[file.documentId] == false
                              "
                              >{{ $t("lblNew") }}</a-chip
                            >
                            {{ file.fileName }}
                          </div>
                        </template>
                        <p class="ma-0">
                          {{ $t("lblFileName") }} : {{ file.fileName }}
                        </p>
                        <p class="ma-0" v-if="file.size">
                          {{ $t("lblFileSize") }} :
                          {{ formatBytes(file.size) }}
                        </p>
                        <p class="ma-0" v-if="file.lastModified">
                          {{ $t("lblLastModifiedTime") }} :
                          {{ convertIntlDateFormat(file.lastModified) }}
                        </p>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-title v-else class="label-m">
                      <a-chip
                        x-small
                        class="pt-0 pl-1 pr-1"
                        color="primaryDark"
                        dark
                        label
                        style="line-height: 10px"
                        v-if="
                          !activeDocumentViews[file.documentId] ||
                          activeDocumentViews[file.documentId] == false
                        "
                        >{{ $t("lblNew") }}</a-chip
                      >
                      {{ file.fileName }}
                      <v-tooltip bottom v-if="file.formData">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            icon
                            x-small
                            v-bind="attrs"
                            v-on="on"
                            v-if="file.formData"
                          >
                            <v-icon>mdi-alert-circle-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t("agenda.unSavedDocument") }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                    <v-list-item-subtitle class="label-s"
                      >{{ formatBytes(file.size) }} -
                      {{ file.mimetype }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action style="flex-direction: row">
                    <v-tooltip bottom v-if="openMeetingDocumentPermission">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="openMeetingDocumentPermission"
                          x-small
                          icon
                          color="neutralGray1"
                          @click="saveDocument(file)"
                          v-bind="attrs"
                          v-on="on"
                          class="mr-3"
                          ><v-icon size="24"> mdi-download</v-icon></v-btn
                        >
                      </template>
                      <span>{{ $t("agenda.tipSaveDoc") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <a-btn
                          v-if="updateMeetingPermission"
                          x-small
                          color="primaryDark"
                          width="24"
                          min-width="24"
                          v-on="on"
                          v-bind="attrs"
                          @click.stop="deleteMOMDocument(file)"
                        >
                          <v-icon size="16" color="#fff"> mdi-delete</v-icon>
                        </a-btn>
                      </template>
                      <span>{{ $t("agenda.tipDeleteDoc") }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div v-else>
                <span class="body-m">{{
                  $t("agenda.noMeetingMinutesDocument")
                }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" class="mt-6">
      <v-card class="element">
        <v-toolbar
          color="primary"
          dense
          flat
          elevation="0"
          dark
          class="panel-header"
          @click="onExpandMOMPanelClick(2)"
        >
          <v-toolbar-title class="h4">
            {{ $t("agenda.lblAttendees") }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                dark
                icon
                v-bind="attrs"
                v-on="on"
                class="mr-1"
                @click.stop="onExpandMOMPanelClick(2)"
              >
                <v-icon v-if="isMOMAttendeesPanelOpen(2)"
                  >mdi-chevron-up
                </v-icon>
                <v-icon v-else>mdi-chevron-down </v-icon>
              </v-btn>
            </template>
            <span v-if="isMOMAttendeesPanelOpen(2)">{{
              $t("lblCollapse")
            }}</span>
            <span v-else>{{ $t("lblExpand") }}</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text v-show="isMOMAttendeesPanelOpen(2)">
          <attendess-panel-card
            :attendees-list="attendeesList"
            @onAttendedStateChanged="onAttendanceChanged"
            @removeAttendees="onRemoveAttendees"
            :meetingObject="meetingObject"
            :isMeetingModified="isMeetingModified"
            :attendanceRows="attendanceRows"
          ></attendess-panel-card>
        </v-card-text>
      </v-card>
    </v-col>

    <confirm-dialog ref="confirm"></confirm-dialog>
    <MessageSheet
      :showMessage="displayMessage"
      :message="message"
      :messageType="messageType"
      @close="displayMessage = false"
    ></MessageSheet>
    <AgendaPage
      :agendaObject="agendaFormData"
      :hasCalledFromMeeting="true"
      v-if="dialogAgenda"
      v-model="dialogAgenda"
      @alert="onAlertMessage"
      @onCreateAgenda="createMeetingAgenda"
    ></AgendaPage>
  </v-row>
</template>
<script>
import TopicTags from "@/components/agenda/TopicTags.vue";
import MeetingPresentor from "@/components/agenda/MeetingPresentor.vue";
import coloredChipTemplate from "@/components/agenda/coloredChipTemplate.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import MeetingParticipantList from "@/components/agenda/MeetingParticipantList";
import PresentorDropdownList from "@/components/agenda/PresentorDropdownList";
import ConfirmDialog from "../ConfirmDialog.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import { createUUID } from "../../utils/util";
import _ from "lodash";
import AgendaPage from "@/components/agenda/agendaPage.vue";
import DataTableRowHandler from "@/components/DataTableRowHandler.vue";
import draggable from "vuedraggable";
import AgendaTopicSelector from "@/components/agenda/agendaTopicSelector.vue";
import ChatForMeeting from "@/components/agenda/chat/ChatForMeeting.vue";
import {
  formatBytes,
  convertIntlDateFormat,
  currentDateTime,
  openDocument,
  formatDate,
} from "../../utils/util";
import { MAX_UPLOAD_SIZE, allowed_file, topic_file_types } from "../../utils/constant";
import ApprovalControl from "./approvalControl.vue";
import { timeDigitTextLimit } from "../../utils/constant";
import Loader from "@/components/Loader.vue";
import MeetingCard from "../../wrapper-component/MeetingCard.vue";
import FileInput from "../../wrapper-component/FileInput.vue";
import AttendessPanelCard from "./AttendessPanelCard.vue";
import TopicMoveMeetingList from "./TopicMoveMeetingList.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import PlaceholderMixin from "../../mixin/PlaceholderMixin";
import EmailAlertNotification from "@/components/EmailAlertNotification.vue";
import MomGenerate from "./MomGenerate.vue";
import MomAnnotation from "./momAnnotation/MomAnnotation.vue";
import MOMSignature from "./mom-signature/MOMSignature.vue";
import TopicMemo from "./TopicMemo.vue";
import TopicFeedback from "./TopicFeedback.vue";
import EmailSelectionDialog from "@/components/EmailSelectionDialog.vue";

export default {
  name: "AgendaTable",
  mixins: [SignalRMixin, PlaceholderMixin],
  props: {
    selectedMeeting: Object,
    topicVotes: Array,
    attendanceRows: Number,
    abstractRows: Number,
  },
  data: function () {
    return {
      section: "",
      listOfTopicWithTag: [],
      render: 0,
      localUserList: [],
      isMeetingModified: false,
      disableUpdateTimeTip: false,
      expandPanel: [],
      meetingListDrawer: false,
      showTimeTextField: true,
      momAttendessPanel: [0, 1, 2],
      meetingCardPanel: 0,
      toggle_status: "open",
      toggle_response: "Approval",
      meetingClick: 0,
      meetingPopup: {},
      approvalStatus: false,
      isSilentRequest: false,
      data: {
        data: {},
        dialogMeeting: false,
        topicCategories: [],
      },
      timeDigitTextLimit: timeDigitTextLimit,
      popupBlocker: false,
      isExpanded: false,

      dialogPresentor: false,
      selectedParticipantList: [],
      displayMessage: false,
      message: "",
      messageType: "",
      agendaFormData: {
        id: "",
        agendaName: "",
        category: "",
        meetingType: "",
        priority: "",
        frequency: "",
        resolutionType: "",
        topics: [],
        tenantid: sessionStorage.getItem("tenantId"),
        memo: "",
      },
      dialogAgenda: false,
      newAgendaObjectList: [],
      catTopics: [],
      momDocs: [],
      activeDocument: [],
      userVotingData: [],
      alertnateContactEmails: [],
      emailAlertSelectionDialog: false,
      dialogRemind: false,
      remindAttendees: [],
      suggestedAttendees: [],
      alertHeading: this.$t("agenda.hNotification"),
      alertTemplate: {},
      openEmailNotificationTemplateDialog: false,
      notificationtype: "",
      meetingPurpose: "",
    };
  },
  components: {
    TopicTags,
    MeetingPresentor,
    coloredChipTemplate,
    MeetingParticipantList,
    PresentorDropdownList,
    ConfirmDialog,
    MessageSheet,
    AgendaPage,
    DataTableRowHandler,
    draggable,
    AgendaTopicSelector,
    ApprovalControl,
    Loader,
    MeetingCard,
    FileInput,
    AttendessPanelCard,
    TopicMoveMeetingList,
    EmailAlertNotification,
    MomGenerate,
    MomAnnotation,
    MOMSignature,
    ChatForMeeting,
    TopicMemo,
    TopicFeedback,
    EmailSelectionDialog,
  },
  async created() {
    try {
      // await this.getTenantConfigList();
      this.detectPopup();
      const topicCategoryList = this.tenantSettingTypes("topiccategory");
      let maxOrder = 0;
      if (topicCategoryList.length) {
        maxOrder = Math.max(...topicCategoryList.map((e) => e.order || 0));
      }
      topicCategoryList.forEach((cat) => {
        if (cat.order) {
          cat.order = ++maxOrder;
        }
      });
      this.data.topicCategories = topicCategoryList
        .map((item) => ({
          ...item,
          order: this.getTopicOrder(item),
        }))
        .sort((a, b) => a.order - b.order);
      this.expandPanel = this.data.topicCategories.map((element) => {
        return element.id;
      });
      this.$eventHub.$on("meetingDataModified", (value) => {
        this.isMeetingModified = value;
      });
      this.$eventHub.$off("onAddInterimPresentor");
      this.$eventHub.$on("onAddInterimPresentor", (presentor) => {
        const list = this.meetingObject.interimPresentorList;
        list.push(presentor);
        this.$eventHub.$emit("onInterimPresentorAdd", list);
      });
      this.$eventHub.$on("isSilentSignalR", this.isSilentSignalR);
    } catch (error) {
      console.log(error, "agenda table");
    }
  },
  destroyed() {
    this.$eventHub.$off("onAddInterimPresentor");
  },
  async mounted() {
    if (this.selectedMeeting.id) {
      const targetVotingTopic = "meeting_voting_" + this.selectedMeeting.id;
      await this.signalRTopicVoting(targetVotingTopic);
      const targetTenentConfig = "tenant_config_" + this.selectedTenant;
      await this.signalRTenentConfig(targetTenentConfig);
      await this.getUserVotingData();
      this.approvalStatus = true;
      if (this.userList.length && !this.localUserList.length) {
        this.localUserList = _.cloneDeep(this.userList);
      }
    }
    if (this.selectedMeeting.id && this.selectedMeeting.attendees.length > 0) {
      let alternateEmailsIds = await this.getAlternateEmailIds();
      this.alertnateContactEmails = this.selectedMeeting.attendees.filter(
        function (person) {
          return alternateEmailsIds.includes(person.email);
        }
      );
    }
  },
  computed: {
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    hasResolutionInWriting() {
      return this.meetingObject.resolutionType === "In Writing";
    },
    attendeesList() {
      return this.meetingObject.attendees.map((obj, index) => ({
        ...obj,
        order: obj.order || index + 1,
      }));
    },
    isAttendee() {
      let attendee = this.meetingObject.attendees.filter(
        (f) =>
          f.email &&
          f.email.toLowerCase().trim() ===
            this.$auth.user.email.toLowerCase().trim()
      );
      if (attendee.length > 0) {
        return true;
      }

      return this.alertnateContactEmails.length > 0;
    },
    isParticipants() {
      if (this.meetingObject.attendees.length == 0) return false;
      const attendees = this.meetingObject.attendees.flatMap((item) => {
        const mainAttendee = { ...item, email: item.email };
        const additionalAttendees = (item.contactEmailIds || [])
          .filter((email) => email)
          .map((email) => ({ ...item, email }));

        return [mainAttendee, ...additionalAttendees];
      });
      return attendees.some((item) => item.email === this.$auth.user.email);
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    agendanumbering() {
      return this.tenantSettingTypes("agendanumbering");
    },
    ...mapState({
      meetingTimerClickState: (state) => state.meeting.meetingTimerClick,
      meetingTimerPopupState: (state) => state.meeting.meetingTimerPopup,
      agendaListData: (state) => state.agenda.agendaListByMeetingType,
      documentViews: (state) => state.document.documentViews,
      userList: (state) => state.people.userList,
    }),
    ...gettersMap(),
    activeDocumentViews() {
      return { ...this.documentViews, ...this.activeDocument };
    },
    countActiveDocuments() {
      return Object.keys(this.activeDocumentViews).length;
    },
    topicDocumentCount() {
      let documents = [];
      this.categorizedTopics.forEach((category) => {
        if (category.topics.length > 0) {
          category.topics.forEach((topic) => {
            if (topic.documents.length > 0) {
              topic.documents.map((x) => {
                const params = {
                  documentId: x.documentId,
                  filename: x.fileName,
                };
                if (!x.formData) {
                  documents.push(params);
                }
              });
            }
          });
        }
      });
      return documents;
    },
    meetingObject: {
      get() {
        return this.selectedMeeting;
      },
      set(val) {
        this.selectedMeeting = val;
      },
    },
    daysInexpire() {
      const diffInMs =
        new Date(this.meetingObject.scheduledEndTimeInUTC) - new Date();
      const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));
      return diffInDays;
    },
    emailTemplate: {
      get() {
        return this.alertTemplate;
      },
      set(val) {
        this.alertTemplate = val;
      },
    },
    getConvocationTemplate() {
      return this.getTemplateByTemplateTypeId(
        "ConvocationMail",
        this.selectedLang
      );
    },
    getRemindVotingTemplate() {
      return this.getTemplateByTemplateTypeId(
        "RemindVotingConsent",
        this.selectedLang
      );
    },
    momDocuments() {
      this.momDocs = this.meetingObject.momDocuments
        ? this.meetingObject.momDocuments
        : [];
      return this.momDocs;
    },
    topics() {
      if (!this.meetingObject.topics) {
        return [];
      }
      let data = this.meetingObject.topics.map((item) => ({
        ...item,
        agenda: this.getAgendaDetails(this.meetingObject.meetingType, item),
      }));
      return data;
    },
    messageDownloadURL() {
      return (
        process.env.VUE_APP_CONVOCATION_SERVICE +
        "convocation/" +
        this.meetingObject.id +
        "?tenant=" +
        this.selectedTenant
      );
    },
    categorizedTopics: {
      get() {
        let meetindNumbering = 0;
        const catList = this.data.topicCategories
          .map((item) => ({
            ...item,
            topics: this.topics
              .filter((s) => s.topicCategory === item.id)
              .sort((a, b) => a.displayOrder - b.displayOrder),
          }))
          .sort((a, b) => a.order - b.order);

        this.catTopics = catList.filter((ca) => {
          return ca.topics.length > 0;
        });

        if (this.catTopics.length > 0) {
          this.catTopics
            .filter(
              (category) =>
                (category.isapprovalrequired === true ||
                  category.isapprovalrequired === "true") &&
                category.topics.length > 0
            )
            .forEach((category) => {
              category.topics.forEach((item) => {
                this.meetingObject.topics.forEach((topic, i) => {
                  if (
                    topic.agendaId === item.agendaId &&
                    topic.Id === item.Id &&
                    !topic.approval
                  ) {
                    topic.approval = { isOpen: true };
                  }
                });
              });
            });
          this.catTopics.forEach((category) => {
            category.topics.forEach((item) => {
              meetindNumbering = meetindNumbering + 1;
              item.meetindNumbering = meetindNumbering;
            });
          });
        }
        return this.catTopics || [];
      },
      set(val) {
        this.catTopics = val;
      },
    },
    isRemindAlert() {
      const notification = [];
      if (this.categorizedTopics.length > 0) {
        this.categorizedTopics
          .filter(
            (cat) =>
              (cat.isapprovalrequired === true ||
                cat.isapprovalrequired === "true") &&
              cat.topics.length > 0
          )
          .forEach((category) => {
            category.topics.forEach((item) => {
              if (item.approval && item.approval.isOpen) {
                notification.push({ topic: item.Id, approval: item.approval });
              }
            });
          });
      }
      return (
        notification.length &&
        this.meetingObject.resolutionType.toLowerCase() === "in writing"
      );
    },
    topicHeaders() {
      return [
        {
          align: " d-none",
          text: "Agenda Title",
          value: "agenda.agendaName",
          sortable: false,
        },
        {
          text: "Agenda & Topics",
          align: "start",
          value: "topicName",
          sortable: false,
          groupable: false,
        },

        {
          align: "start",
          text: "Category",
          value: "topicCategory",
          groupable: false,
          sortable: false,
        },
        {
          align: "start",
          text: "Priority",
          value: "agenda.priority",
          width: 80,
          groupable: false,
          sortable: false,
        },
        {
          align: "start",
          text: "Scheduled Time",
          value: "timeInMinutes",
          width: 80,
          groupable: false,
          sortable: false,
        },
        {
          align: " d-none",
          text: "Actual Time",
          value: "actualTime",
          class: "appBar",
          sortable: false,
          groupable: false,
        },
        {
          align: "start",
          text: "Presentor",
          value: "peopleInCharge",
          class: "presentorHeader",
          sortable: false,
          groupable: false,
        },
        {
          align: "start",
          text: "Documents",
          value: "documents",
          groupable: false,
          sortable: false,
        },
      ];
    },
    topicHeads() {
      return [
        {
          text: "Agenda & Topics",
          align: "start",
          value: "topicName",
          sortable: false,
          groupable: false,
          width: "31%",
        },
        {
          align: "start",
          text: "Priority",
          value: "agenda.priority",
          width: 80,
          groupable: false,
          sortable: false,
        },
        {
          align: "start",
          text: "Scheduled Time",
          value: "timeInMinutes",
          width: 80,
          groupable: false,
          sortable: false,
        },

        {
          align: "start",
          text: "Presentor",
          value: "peopleInCharge",
          class: "presentorHeader",
          sortable: false,
          groupable: false,
        },
        {
          align: "start",
          text: "Documents",
          value: "documents",
          groupable: false,
          sortable: false,
        },
      ];
    },
    updateMeetingPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    generateTranscriptionPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "GenerateTranscription"
        );
      }
      return false;
    },
    momESignatureManagement() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "MomESignatureManagement"
        );
      }
      return false;
    },
    viewMomCommentPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "ViewMomComment"
        );
      }
      return false;
    },
    sendMomCommentNotificationPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "SendMomCommentNotification"
        );
      }
      return false;
    },
    viewTagPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "ViewTag"
        );
      }
      return false;
    },
    votingRightPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "VotingRight"
        );
      }
      return false;
    },
    auditorConsentPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "AuditorConsent"
        );
      }
      return false;
    },
    downloadConvocationPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "DownloadConvocation"
        );
      }
      return false;
    },
    viewMeetingTimerPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "ViewMeetingTimer"
        );
      }
      return false;
    },
    openMeetingDocumentPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "OpenMeetingDocument"
        );
      }
      return false;
    },
    topicFeedbackPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "CreateTopicFB"
        );
      }
      return false;
    },
    presenterList() {
      const interimList = this.meetingObject.interimPresentorList.map((p) => {
        return {
          attendedState: null,
          contactEmailIds: [],
          firstName: p.name,
          id: p.id,
          lastName: null,
          profilePhoto: null,
          title: p.title,
          isInterimPresentor: true,
        };
      });
      const presentorList = this.attendeesList.concat(interimList);
      return presentorList;
    },
    updatedUserList: {
      get() {
        return this.localUserList;
      },
      set(value) {
        this.localUserList = value;
      },
    },
    displayDateFormat() {
      return this.selectedLang !== "ja"
        ? "dd/MM/yyyy hh:mm aaa"
        : "yyyy/MM/dd HH:mm";
    },
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd/MM/yyyy" : "yyyy/MM/dd";
    },
  },
  methods: {
    showSaveTagMsg(show) {
      if (show) {
        this.showMessageSheet(this.$t("agenda.msgSaveTagSuccess"), "success");
      }
    },
    isSilentSignalR(status){
      this.isSilentRequest = status
    },
    topicWithSavedTag(topic) {
      if (Object.keys(topic).length) {
        this.meetingObject.topics.forEach((meetTopic) => {
          if (
            meetTopic.Id === topic.Id &&
            meetTopic.agendaId === topic.agendaId
          ) {
            meetTopic.tags = topic.tags;
          }
        });

        if (this.listOfTopicWithTag.length) {
          this.listOfTopicWithTag.forEach((item) => {
            if (item.Id !== topic.Id) {
              this.listOfTopicWithTag.push(topic);
            }
          });
        } else {
          this.listOfTopicWithTag.push(topic);
        }
      }
    },
    isLoader(val) {},
    openAgenda(event) {
      if (event.target.text == this.$t("agenda.lblManageAgenda")) {
        this.$root.$emit("manage-agenda-dialog", true);
      }
      setTimeout(() => {
        this.render++;
      }, 100);
    },
    updateTimeEvent(value) {
      if (value) {
        this.disableUpdateTimeTip = true;
      } else {
        this.disableUpdateTimeTip = false;
      }
    },
    getAgendaDetails(meetingType, item) {
      let agendaDetails = {};
      if (this.agendaListData && this.agendaListData.length > 0) {
        agendaDetails = this.agendaListData.filter(
          (f) => f.id === item.agendaId
        )[0]
          ? this.agendaListData.filter((f) => f.id === item.agendaId)[0]
          : this.newAgendaObjectList.filter((f) => f.id === item.agendaId)[0];
      }

      return agendaDetails;
    },
    async getAlternateEmailIds() {
      let contactEmailIds = [];
      await this.getUserByEmailId(this.$auth.user.email.toLowerCase().trim())
        .then((response) => {
          let user = response;
          if (user.contactEmailIds) {
            contactEmailIds = user.contactEmailIds;
          }
        })
        .catch((error) => {});
      return contactEmailIds;
    },
    onAttendanceChanged(attendees) {
      this.$eventHub.$emit("onMeetingUpdate", attendees);
    },
    onRemoveAttendees(attendee) {
      let topics = this.meetingObject.topics;
      topics.forEach((topic) => {
        topic.peopleInCharge = topic.peopleInCharge.filter(
          (id) => id !== attendee.id
        );
      });
    },
    getVote(topicid) {
      if (this.userVotingData.length) {
        return this.userVotingData.find((s) => s.topicId === topicid) || null;
      }
      return null;
    },
    getTopicOrder(item) {
      if (!this.meetingObject.topicCategories) {
        return item.order;
      }
      let cat = this.meetingObject.topicCategories.find(
        (f) => f.id === item.id
      );
      if (cat) {
        return cat.order;
      }

      return item.order;
    },
    formatBytes,
    convertIntlDateFormat,
    currentDateTime,
    ...mapActions({
      setMeetingTimerCount: "meeting/setMeetingTimerCount",
      setMeetingTimerPopup: "meeting/setMeetingTimerPopup",
      getUserMeetingVotes: "meeting/getUserMeetingVotes",
      deleteDocuments: "document/deleteDocuments",
      createDocuments: "document/createDocuments",
      updateMeetingData: "meeting/updateMeeting",
      getMeetingDetails: "meeting/getMeetingById",
      getVotesMeetingDetails: "meeting/getShortMeetingById",
      getDocumentsByMeetingId: "document/getDocumentsByMeetingId",
      getConvocation: "meeting/getConvocationById",
      getTenantConfigList: "tenant/getUpdatedTenantConfigList",
      downloadDocumentAPI: "document/downloadDocument",
      downloadConvocationMessageAPI: "meeting/downloadConvocationMessage",
      addDocumentView: "document/addDocumentView",
      getUserByEmailId: "admin/getUserByEmailId",
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
      getVotersDetails: "meeting/getVotersDetails",
      getMeetingTopicVote: "meeting/getMeetingTopicVote",
      setVotingData: "meeting/setVotingData",
    }),
    onScheduleTimeUpdate(topic) {
      let meetTopic = this.meetingObject.topics.find(
        (s) => String(s.Id).toLowerCase() === String(topic.Id).toLowerCase()
      );
      const meetTopicTime = String(meetTopic.timeInMinutes);
      if (
        meetTopic &&
        String(topic.timeInMinutes).length <= this.timeDigitTextLimit
      ) {
        if (
          String(topic.timeInMinutes).length > 0 &&
          meetTopicTime !== String(topic.timeInMinutes)
        ) {
          meetTopic.timeInMinutes = topic.timeInMinutes;
          topic.timeInMinutes = meetTopicTime;
          this.$eventHub.$emit("onMeetingUpdate");
        } else if (String(topic.timeInMinutes) == "") {
          meetTopic.timeInMinutes = meetTopicTime;
          topic.timeInMinutes = meetTopicTime;
        }
      }
    },
    showParticipantChangeDialog(participantsList) {
      this.selectedParticipantList = participantsList;
      this.dialogPresentor = true;
    },
    closeAlert() {
      this.popupBlocker = false;
    },
    hasTopicsForCategory(cat) {
      if (this.getTopicArray(cat).length > 0) return true;
      return false;
    },
    getTopicArray(cat) {
      return this.topics.filter((s) => s.topicCategory === cat);
    },
    onAlertMessage: function (message, MessageType) {
      this.showMessageSheet(message, MessageType);
    },
    async onApprovalChange(topic) {
      if (this.selectedMeeting.id) {
        await this.getUserVotingData();
        this.$eventHub.$emit("changeVoatingStatus");
      }
    },
    onApprovalSettingChange(topic) {
      this.$eventHub.$emit("onMeetingUpdate");
      this.$eventHub.$emit("saveOnApproval", topic);
    },
    onChangePresentor(topic) {
      let meetTopic = this.meetingObject.topics.find(
        (s) => String(s.Id).toLowerCase() === String(topic.Id).toLowerCase()
      );
      if (meetTopic) {
        meetTopic.peopleInCharge = topic.peopleInCharge;

        this.$eventHub.$emit("onMeetingUpdate");
      }
    },

    handleTopicSelection(meeting) {
      this.$eventHub.$emit("onMeetingUpdate");
    },
    async createMeetingAgenda(agenda) {
      this.$root.$emit("add-agenda", agenda);
    },

    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },

    addDropFile(e, item) {
      this.filesChange(e.dataTransfer.files, item);
    },
    filesChange(fileList, rowData) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      const documents = [];
      const filesWithStatus = [];
      for (let item of fileList) {
        if (!topic_file_types.includes(item.type)) {
          filesWithStatus.push(
            this.$t("fileErrorMsg", { filename: item.name })
          );
        } else if (item.size > maxSize) {
          filesWithStatus.push(
            this.$t("fileSizeErrorMsg", { maxsize: formatBytes(maxSize) })
          );
        } else {
          documents.push(item);
        }
      }
      if (filesWithStatus.length > 0) {
        this.showMessageSheet(filesWithStatus.join("/n"), "error");
        document.getElementById(rowData.Id).value = "";
      }
      let formData;
      Array.from(Array(documents.length).keys()).map(async (x) => {
        const newDocObj = {
          documentId: null,
          tenantid: this.selectedTenant,
          topicId: rowData.Id,
          meetingid: this.meetingObject.id,
          agendaid: rowData.agendaId,
          directoryid: "",
          peopleid: "",
          fileName: "",
          mimetype: "",
          formData: null,
          action: "add",
        };

        let documentId = createUUID();
        formData = new FormData();
        formData.append("tenantId", this.selectedTenant);
        formData.append("topicId", rowData.Id);
        formData.append("documentId", documentId);
        formData.append("meetingId", this.meetingObject.id);
        formData.append("agendaId", rowData.agendaId);
        formData.append("directoryId", "");
        formData.append("peopleId", "");
        formData.append("file", documents[x]);

        formData.append("chunk_upload", false);
        formData.append("filename", documents[x].name);
        formData.append("content_type", documents[x].type);
        formData.append("document_type", "general_document");
        newDocObj.formData = formData;
        newDocObj.documentId = documentId;
        newDocObj.fileName = documents[x].name;
        newDocObj.mimetype = documents[x].type;
        newDocObj.size = documents[x].size;
        newDocObj.lastModified = currentDateTime(documents[x].lastModifiedDate);
        rowData.documents.push(newDocObj);
      });
      if (documents.length) {
        this.$eventHub.$emit("onMeetingUpdate");
      }

      const input = this.$refs["fileInput" + rowData.Id];
      if (input.length) {
        input[0].reset();
      }
    },

    addDropMeetingMinutesFile(e) {
      this.meetingMinutesChanged(e.dataTransfer.files);
    },
    meetingMinutesChanged(fileList) {
      const maxSize = MAX_UPLOAD_SIZE ?? 0;
      const documents = [];
      const filesWithStatus = [];
      for (let item of fileList) {
        if (!allowed_file.includes(item.type)) {
          filesWithStatus.push(
            this.$t("fileErrorMsg", { filename: item.name })
          );
        } else if (item.size > maxSize) {
          filesWithStatus.push(
            this.$t("fileSizeErrorMsg", { maxsize: formatBytes(maxSize) })
          );
        } else {
          documents.push(item);
        }
      }
      if (filesWithStatus.length > 0) {
        this.showMessageSheet(filesWithStatus.join("/n"), "error");
        document.getElementById("momDocument").value = "";
      }
      let formData;
      Array.from(Array(documents.length).keys()).map(async (x) => {
        const newDocObj = {
          documentId: null,
          tenantid: this.selectedTenant,
          topicId: "",
          meetingid: this.meetingObject.id,
          agendaid: "",
          directoryid: "",
          peopleid: "",
          fileName: "",
          mimetype: "",
          size: "",
          lastModified: "",
          formData: null,
          action: "add",
        };

        let documentId = createUUID();
        formData = new FormData();
        formData.append("tenantId", this.selectedTenant);
        formData.append("topicId", "");
        formData.append("documentId", documentId);
        formData.append("meetingId", this.meetingObject.id);
        formData.append("agendaId", "");
        formData.append("directoryId", "");
        formData.append("peopleId", "");
        formData.append("file", documents[x]);

        formData.append("chunk_upload", false);
        formData.append("filename", documents[x].name);
        formData.append("content_type", documents[x].type);

        newDocObj.formData = formData;

        newDocObj.documentId = documentId;
        newDocObj.fileName = fileList[x].name;
        newDocObj.mimetype = fileList[x].type;
        newDocObj.size = fileList[x].size;
        (newDocObj.lastModified = currentDateTime(fileList[x].lastModified)),
          this.momDocs.push(newDocObj);
        this.meetingObject.momDocuments = this.momDocs;
      });
      this.$eventHub.$emit("onMeetingUpdate");
      this.$refs.momInputUpload.reset();
    },
    async documentDownload(item) {
      if (item.action === "add") {
        this.showMessageSheet(this.$t("agenda.CannotOpenDocInfo"), "info");
      } else {
        const params = {
          documentId: item.documentId,
          filename: item.fileName,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        this.activeDocument = {
          ...this.activeDocument,
          ...{ [item.documentId]: true },
        };

        this.addDocumentView(item.documentId);
        openDocument(url, item.fileName);
      }
    },

    async saveDocument(item) {
      if (item.action === "add") {
        this.showMessageSheet(this.$t("agenda.CannotSaveDocInfo"), "info");
      } else {
        const params = {
          documentId: item.documentId,
          filename: item.fileName,
        };
        const res = await this.downloadDocumentAPI(params);
        var contentType = res.headers["content-type"];
        var blob = new Blob([res.data], { type: contentType });
        var url = window.URL.createObjectURL(blob);
        this.activeDocument = {
          ...this.activeDocument,
          ...{ [item.documentId]: true },
        };

        this.addDocumentView(item.documentId);
        this.downloadMessage(url, item.fileName);
      }
    },

    detectPopup() {
      var popupWindow = window.open(
        "about:blank",
        "new_window_123",
        "height=1,width=1"
      );

      if (!popupWindow) {
        this.popupBlocker = true;
      } else {
        this.popupBlocker = false;
        popupWindow.close();
      }
    },
    openMeetingTimer() {
      let popup;
      let routeData = this.$router.resolve({
        path: "/meetingTimer/" + this.meetingObject.id,
      });

      if (this.meetingTimerPopupState.closed && this.meetingTimerClickState) {
        // Check conditions if the popup is closed.
        this.meetingClick = this.meetingTimerClickState;
        this.meetingPopup = this.meetingTimerPopupState;
      } else if (
        this.meetingTimerClickState > 1 &&
        this.meetingTimerPopupState &&
        Object.keys(this.meetingTimerPopupState).length
      ) {
        // Check the conditions if the popup is already open after updating the meeting
        if (this.meetingTimerPopupState.location.pathname === routeData.href) {
          this.meetingClick = this.meetingTimerClickState;
          this.meetingPopup = this.meetingTimerPopupState;
        } else {
          this.meetingClick = 1;
        }
      } else if (
        this.meetingTimerClickState === 1 &&
        this.meetingTimerPopupState &&
        Object.keys(this.meetingTimerPopupState).length
      ) {
        if (this.meetingTimerPopupState.location.pathname === routeData.href) {
          this.meetingClick = this.meetingTimerClickState + 1;
          this.meetingPopup = this.meetingTimerPopupState;
        } else {
          this.meetingClick = this.meetingTimerClickState;
        }
      } else if (
        this.meetingTimerClickState &&
        Object.keys(this.meetingTimerPopupState).length === 0
      ) {
        this.meetingClick = 1;
      } else {
        this.meetingClick = this.meetingTimerClickState + 1;
      }

      // let height = screen.height;
      // let width = screen.width;
      let height = 500;
      let width = 750;
      // Calculate the position to center the window
      const left =
        (window.innerWidth - width) / 2 + window.screenLeft || window.screenX;
      const top =
        (window.innerHeight - height) / 2 + window.screenTop || window.screenY;
      // let strWindowFeatures =
      //   "location=no,toolbar=no,menubar=no,height=" +
      //   500 +
      //   ",width=" +
      //   700 +
      //   ",scrollbars=auto,fullscreen=no";
      let strWindowFeatures = `location=no,
                         toolbar=no,
                         menubar=no,
                         height=${height},
                         width=${width},
                         scrollbars=auto,
                         fullscreen=no,
                         top=${top},
                         left=${left}`;

      // let height = screen.height;
      // let width = screen.width;
      // let strWindowFeatures =
      //   "location=no,toolbar=no,menubar=no,height=" +
      //   height +
      //   ",width=" +
      //   width +
      //   ",scrollbars=auto,fullscreen=yes";

      this.setMeetingTimerCount(this.meetingClick);
      if (
        this.meetingClick === 1 ||
        typeof this.meetingPopup === "undefined" ||
        this.meetingPopup.closed
      ) {
        popup = window.open(routeData.href, "_blank", strWindowFeatures);
        this.meetingPopup = popup;
        // popup.moveTo(0, 0);
        if (window.focus) {
          popup.focus();
        }
        this.setMeetingTimerPopup(this.meetingPopup);
      } else {
        this.meetingPopup.focus();
        this.setMeetingTimerPopup(this.meetingPopup);
      }
    },
    createAgenda() {
      this.agendaFormData = {
        id: "",
        agendaName: "",
        category: "",
        meetingType: this.meetingTypesList.find(
          (c) =>
            String(c.label).toLowerCase() ===
            String(this.meetingObject.meetingType).toLowerCase()
        ) || { label: this.meetingObject.meetingType, color: "#F5CBA7" },
        priority: "",
        frequency: "",
        resolutionType: "",
        topics: [],
        tenantid: this.selectedTenant,
        memo: "",
        action: "add",
      };
      this.dialogAgenda = true;
    },

    editAgenda(agendaObj) {
      this.agendaFormData = Object.assign({}, agendaObj);

      this.dialogAgenda = true;
    },

    async OpenAllDocuments() {
      try {
        if (this.popupBlocker) {
          await this.popupBlockerAlert();
          return;
        }
        let isDocumentExist = false;

        let promises = [];
        let receivedData;
        this.categorizedTopics.forEach((category) => {
          if (category.topics.length > 0) {
            category.topics.forEach((topic) => {
              if (topic.documents.length > 0) {
                isDocumentExist = true;
                topic.documents.map((x) => {
                  const params = {
                    documentId: x.documentId,
                    filename: x.fileName,
                  };
                  if (!x.formData) {
                    this.activeDocument = {
                      ...this.activeDocument,
                      ...{ [x.documentId]: true },
                    };
                    const docBlob = this.downloadDocumentAPI(params);
                    promises.push(docBlob);
                  }
                });
              }
            });
          }
        });
        receivedData = await Promise.all(promises);
        receivedData.map(async (x) => await this.handleDownloadResponse(x));
        if (!isDocumentExist) {
          this.showMessageSheet(this.$t("agenda.NoDocAttached"), "info");
        }
      } catch (error) {
        console.error(error);
      }
    },

    async SaveAllDocuments() {
      try {
        let isDocumentExist = false;

        let promises = [];
        let receivedData;
        this.categorizedTopics.forEach((category) => {
          if (category.topics.length > 0) {
            category.topics.forEach((topic) => {
              if (topic.documents.length > 0) {
                isDocumentExist = true;
                topic.documents.map((x) => {
                  const params = {
                    documentId: x.documentId,
                    filename: x.fileName,
                  };

                  if (!x.formData) {
                    this.activeDocument = {
                      ...this.activeDocument,
                      ...{ [x.documentId]: true },
                    };
                    const docBlob = this.downloadDocumentAPI(params);
                    promises.push(docBlob);
                  }
                });
              }
            });
          }
        });
        receivedData = await Promise.all(promises);
        receivedData.map(
          async (x) => await this.handleDownloadResponse(x, true)
        );
        if (!isDocumentExist) {
          this.showMessageSheet(this.$t("agenda.NoDocAttached"), "info");
        }
      } catch (error) {
        console.error(error);
      }
    },

    async handleDownloadResponse(res, isSave = false) {
      var fileName = res.config.fileName;
      var contentType = res.headers["content-type"];
      var blob = new Blob([res.data], { type: contentType });
      var url = window.URL.createObjectURL(blob);
      if (isSave) {
        this.downloadMessage(url, fileName);
      } else {
        openDocument(url, fileName);
      }
    },

    downloadMessage(url, name) {
      var a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = name;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    base64ToArrayBuffer(base64) {
      //var binaryString =  window.atob(base64);

      var binaryLen = binaryString.length;
      var bytes = new Uint8Array(binaryLen);
      for (var i = 0; i < binaryLen; i++) {
        var ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
      }
      return bytes;
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index == "topicCategory") {
          let x = this.getTopicCategoryOrder(a[index]);
          let y = this.getTopicCategoryOrder(b[index]);
          if (!isDesc) {
            return x > y ? -1 : 1;
          } else {
            return y > x ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    getDay(meetingdate) {
      var Xmas95 = new Date(meetingdate);
      //alert(this.selectedLang);
      var options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
      return Xmas95;
    },
    getTopicCategoryText(cat) {
      //let categoryVal = cat.charAt(0);
      return this.data.topicCategories.find((v) => v.value === cat).name;
    },
    getTopicCategoryOrder(cat) {
      //let categoryVal = cat.charAt(0);
      return this.data.topicCategories.find((v) => v.value === cat).order;
    },
    getPresenter(picID) {
      const interimList = this.meetingObject.interimPresentorList.map((p) => {
        return {
          attendedState: null,
          contactEmailIds: [],
          firstName: p.name,
          id: p.id,
          lastName: null,
          profilePhoto: null,
          title: p.title,
          isInterimPresentor: true,
        };
      });
      const presentorList = this.attendeesList.concat(interimList);
      return (
        presentorList.find(
          (a) =>
            String(a.id).toLowerCase().trim() ===
            String(picID).toLowerCase().trim()
        ) || null
      );
    },
    async confirmTopicRemoval(item) {
      if (
        await this.$refs.confirm.open(
          this.$t("lblConfirmRemoval"),
          this.selectedLang === "ja"
            ? item.topicName + " " + this.$t("msgConfirmRemoval")
            : this.$t("msgConfirmRemoval") + " " + item.topicName + "?",
          { yesNoButtons: true }
        )
      ) {
        this.removeTopic(item);
      }
    },
    removeTopic(item, isMoveTopic = false) {
      this.listOfTopicWithTag.forEach((tagTopic) => {
        if (tagTopic.Id === item.Id && isMoveTopic) {
          this.meetingObject.movedTopicList.forEach((obj) => {
            obj.topics.forEach((topic) => {
              if (
                tagTopic.Id === topic.Id &&
                tagTopic.agendaId === topic.agendaId
              ) {
                topic.tags = tagTopic.tags;
              }
            });
          });
        }
      });
      if (item.documents.length > 0 && !isMoveTopic) {
        item.documents.forEach((doc) => {
          if (doc.action !== "add") {
            this.$eventHub.$emit("onDeleteDocuments", doc.documentId);
          }
        });
      }
      const topicsList = _.cloneDeep(this.meetingObject.topics);
      this.meetingObject.topics = this.meetingObject.topics.filter(
        (f) => f.Id != item.Id
      );
      if (
        JSON.stringify(topicsList) !==
          JSON.stringify(this.meetingObject.topics) &&
        !isMoveTopic
      ) {
        this.$eventHub.$emit("onMeetingUpdate");
      }
    },

    removeUnSavedTopics(agenda) {
      agenda.topics.forEach((topic) => {
        this.removeTopic(topic);
      });
    },

    async onRemoveInterimPresentor(presentorId) {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hDeleteMessage"),
          this.$t("agenda.lblDeleteMessage")
        )
      ) {
        this.meetingObject.topics.forEach((item) => {
          item.peopleInCharge = item.peopleInCharge.filter(
            (id) => id !== presentorId
          );
        });
        this.meetingObject.interimPresentorList =
          this.meetingObject.interimPresentorList.filter(
            (item) => item.id !== presentorId
          );
        this.$eventHub.$emit("onMeetingUpdate");
      }
    },

    groupBy(array, key) {
      // Return the end result
      return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
          currentValue
        );
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
      }, {}); // empty object is the initial value for result object
    },
    groupByKey(array, key) {
      return array.reduce((hash, obj) => {
        if (obj[key] === undefined) return hash;
        return Object.assign(hash, {
          [obj[key]]: (hash[obj[key]] || []).concat(obj),
        });
      }, {});
    },
    onChanged(evt, category) {
      for (var i = evt.moved.newIndex; i < category.topics.length; i++) {
        let topic = category.topics[i];
        topic.displayOrder = i;
        let metTopic = this.meetingObject.topics.find((f) => f.Id === topic.Id);
        if (metTopic) {
          metTopic.displayOrder = i;
        }
      }
      this.$eventHub.$emit("onMeetingUpdate");
    },

    onDocOrderChanged(evt, topic) {
      // Keep meetingObject documents in the same array order as the UI
      const meetTopic = this.meetingObject.topics.find(
        (t) => t.Id === topic.Id
      );
      if (meetTopic) {
        // Point to the same array so future drags keep them in sync automatically
        meetTopic.documents = topic.documents;
      }
      this.$eventHub.$emit("onMeetingUpdate");
    },

    topicMoveUp(topic, parentIndex, index) {
      const category = this.categorizedTopics[parentIndex];
      if (!category || !Array.isArray(category.topics)) return;

      // Normalize first if duplicate displayOrder values exist
      this._resequenceCategoryTopics(category);

      // Determine current real index in category.topics (not by sorted order)
      const currentIdx = category.topics.findIndex((t) => t.Id === topic.Id);
      if (currentIdx <= 0) return; // Already at top

      // Swap positions in the category topics array (UI order source)
      const temp = category.topics[currentIdx - 1];
      category.topics[currentIdx - 1] = category.topics[currentIdx];
      category.topics[currentIdx] = temp;

      // Resequence deterministic displayOrder values after swap
      this._resequenceCategoryTopics(category);

      // Reflect new orders into master meetingObject.topics list
      this._syncTopicOrders(category);

      this.$eventHub.$emit("onMeetingUpdate");
    },

    topicMovedown(topic, parentIndex, index) {
      const category = this.categorizedTopics[parentIndex];
      if (!category || !Array.isArray(category.topics)) return;

      this._resequenceCategoryTopics(category);
      const currentIdx = category.topics.findIndex((t) => t.Id === topic.Id);
      if (currentIdx === -1 || currentIdx >= category.topics.length - 1) return; // Bottom

      const temp = category.topics[currentIdx + 1];
      category.topics[currentIdx + 1] = category.topics[currentIdx];
      category.topics[currentIdx] = temp;

      this._resequenceCategoryTopics(category);
      this._syncTopicOrders(category);
      this.$eventHub.$emit("onMeetingUpdate");
    },
    _resequenceCategoryTopics(category) {
      // Assign sequential integers starting at 0 in visible order
      category.topics.forEach((t, i) => {
        t.displayOrder = i;
        const master = this.meetingObject.topics.find((m) => m.Id === t.Id);
        if (master) master.displayOrder = i;
      });
    },
    _syncTopicOrders(category) {
      // Ensure meetingObject.topics reflect updated orders from category.topics
      category.topics.forEach((t) => {
        const master = this.meetingObject.topics.find((m) => m.Id === t.Id);
        if (master) master.displayOrder = t.displayOrder;
      });
    },
    changeCategoryOrderUpDown(isUpMove, categoryId) {
      let categories = this.data.topicCategories.sort(
        (a, b) => a.order - b.order
      );

      const index = this.categorizedTopics.findIndex(
        (c) => c.id === categoryId
      );
      const uIndex = isUpMove ? index - 1 : index + 1;
      const updatedTopic = this.categorizedTopics[uIndex];
      for (var i = 0; i < categories.length; i++) {
        let topic = categories[i];
        if (topic.id === categoryId) {
          topic.order = uIndex;
        } else if (topic.id === updatedTopic.id) {
          topic.order = index;
        } else {
          topic.order = i;
        }
      }

      this.meetingObject.topicCategories = categories.sort(
        (a, b) => a.order - b.order
      );

      this.$eventHub.$emit("onMeetingUpdate");
    },
    onCatOrderChanged(evt) {
      for (
        var i = evt.moved.newIndex;
        i < this.data.topicCategories.length;
        i++
      ) {
        let topic = this.data.topicCategories[i];
        topic.order = i;
      }
      this.meetingObject.topicCategories = this.data.topicCategories;
      this.$eventHub.$emit("onMeetingUpdate");
    },
    checkAccessPermission(evt) {
      evt.preventDefault();
    },
    filterKey(e) {
      const key = e.key;
      if (key === ".") return e.preventDefault();
      if (key === "e") return e.preventDefault();
      if (key === "-") return e.preventDefault();
    },
    onTimeMenuEnter(refMenu) {
      this.$refs[refMenu][0].isActive = false;
      this.showTimeTextField = false;
      this.$nextTick(() => {
        this.showTimeTextField = true;
        // item.timeInMinutes = textValue;
      });
    },
    onSaveTime(refMenu, refTime, item) {
      this.$refs[refMenu][0].isActive = false;
      const textValue = this.$refs[refTime][0].$el.querySelector("input").value;
      item.timeInMinutes =
        textValue && textValue.toString() ? parseInt(textValue.toString()) : "";
      this.onScheduleTimeUpdate(item);
    },
     async votingAlertDialog() {
      try {
        let meetingPurpose = "";

        this.categorizedTopics.forEach((category) => {
          meetingPurpose += `<ul style="list-style: none; margin-left: 0; padding-left: 0; font-size: 11pt;">
              <li>${category.name}<ul style="list-style: none;">
            `;

          category.topics.forEach((topic, index) => {
            const number =
              this.agendanumbering === "numbering_for_meeting"
                ? `${topic.meetindNumbering}.`
                : this.agendanumbering === "numbering_for_category"
                ? `${index + 1}.`
                : "";

            const liStyle =
              this.agendanumbering === "" ||
              this.agendanumbering === "no_numbering"
                ? ""
                : "list-style-type: none";

            meetingPurpose += `
                <li>
                  ${topic.agenda.agendaName}
                  <ul>
                    <li style="${liStyle}">${number} ${topic.topicName}</li>
                  </ul>
                </li>
              `;
          });

          meetingPurpose += `</ul></li></ul>`;
        });

        const placeHolderVariables = this.replaceMeetingDataPlaceholders(
          this.meetingObject,
          meetingPurpose
        );
        this.alertTemplate = {
          subject: this.getRemindVotingTemplate.subject.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          ),
          message: this.getRemindVotingTemplate.body.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          ),
          mailType: "meeting-voting-alert",
          dynamicVariables: {
            targetId: this.meetingObject.id,
            targetTitle: this.meetingObject.meetingName,
            meetingTypeId: this.getMeetingTypeId,
            targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
            targetLink: `${window.location.origin}/meeting/${this.meetingObject.id}/agenda/tenant/${this.selectedTenant}`,
          },
        };
        const response = await this.getVotersDetails(this.selectedMeeting.id);
        this.suggestedAttendees = response.data.all;
        this.remindAttendees = response.data.defaulter;
        this.alertHeading = this.$t("agenda.hNotification");
        this.section = "remindVotingConsent";
        this.dialogRemind = true;
      } catch (error) {
        console.log(error, "api error");
      }
    },
    async remindAlertDialog() {
      try {
        this.meetingPurpose = "";

        this.categorizedTopics.forEach((category) => {
          this.meetingPurpose += `<ul style="list-style: none; margin-left: 0; padding-left: 0; font-size: 11pt;">
              <li>${category.name}<ul style="list-style: none;">
            `;

          category.topics.forEach((topic, index) => {
            const number =
              this.agendanumbering === "numbering_for_meeting"
                ? `${topic.meetindNumbering}.`
                : this.agendanumbering === "numbering_for_category"
                ? `${index + 1}.`
                : "";

            const liStyle =
              this.agendanumbering === "" ||
              this.agendanumbering === "no_numbering"
                ? ""
                : "list-style-type: none";

            this.meetingPurpose += `
                <li>
                  ${topic.agenda.agendaName}
                  <ul>
                    <li style="${liStyle}">${number} ${topic.topicName}</li>
                  </ul>
                </li>
              `;
          });

          this.meetingPurpose += `</ul></li></ul>`;
        });

        const placeHolderVariables = this.replaceMeetingDataPlaceholders(
          this.meetingObject,
          this.meetingPurpose
        );
        this.alertTemplate = {
          subject: this.getRemindVotingTemplate.subject.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          ),
          message: this.getRemindVotingTemplate.body.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          ),
          mailType: "meeting-voting-alert",
          dynamicVariables: {
            targetId: this.meetingObject.id,
            targetTitle: this.meetingObject.meetingName,
            meetingTypeId: this.getMeetingTypeId,
            targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
            targetLink: `${window.location.origin}/meeting/${this.meetingObject.id}/agenda/tenant/${this.selectedTenant}`,
          },
        };
        const response = await this.getVotersDetails(this.selectedMeeting.id);
        this.suggestedAttendees = response.data.all;
        this.remindAttendees = response.data.defaulter;
        this.alertHeading = this.$t("agenda.hNotification");
        this.section = "RemindVotingConsent";
        this.emailAlertSelectionDialog = true;
      } catch (error) {
        console.log(error, "api error");
      }
    },
    async remindAlertConvocation() {
      try {
        this.meetingPurpose = "";

        this.categorizedTopics.forEach((category) => {
          this.meetingPurpose += `<ul style="list-style: none; margin-left: 0; padding-left: 0; font-size: 11pt;">
              <li>${category.name}<ul style="list-style: none;">
            `;

          category.topics.forEach((topic, index) => {
            const number =
              this.agendanumbering === "numbering_for_meeting"
                ? `${topic.meetindNumbering}.`
                : this.agendanumbering === "numbering_for_category"
                ? `${index + 1}.`
                : "";

            const liStyle =
              this.agendanumbering === "" ||
              this.agendanumbering === "no_numbering"
                ? ""
                : "list-style-type: none";

            this.meetingPurpose += `
                <li>
                  ${topic.agenda.agendaName}
                  <ul>
                    <li style="${liStyle}">${number} ${topic.topicName}</li>
                  </ul>
                </li>
              `;
          });

          this.meetingPurpose += `</ul></li></ul>`;
        });

        const placeHolderVariables = this.replaceMeetingDataPlaceholders(
          this.meetingObject,
          this.meetingPurpose
        );
        this.alertTemplate = {
          subject: this.getConvocationTemplate.subject.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          ),
          message: this.getConvocationTemplate.body.replace(
            /{{%[^}]+%}}/g,
            (match) => placeHolderVariables[match] || ""
          ),
          mailType: "meeting-convocation",
          dynamicVariables: {
            targetId: this.meetingObject.id,
            targetTitle: this.meetingObject.meetingName,
            meetingTypeId: this.getMeetingTypeId,
            targetLinkLabel: this.$t("agenda.meetingTargetLinkLabel"),
            targetLink: `${window.location.origin}/meeting/${this.meetingObject.id}/agenda/tenant/${this.selectedTenant}`,
          },
        };

        this.suggestedAttendees = this.meetingObject.attendees;
        this.remindAttendees = this.meetingObject.attendees;
        this.alertHeading = this.$t("agenda.convoHeading");
        this.section = "ConvocationMail";
        this.emailAlertSelectionDialog = true;
      } catch (error) {
        console.log(error, "api error");
      }
    },
    onEmailSend(isSucess) {
      if (isSucess) {
        this.showMessageSheet(
          this.$t("agenda.SendEmailNotification"),
          "success"
        );
      } else {
        this.showMessageSheet(
          this.$t("agenda.FaildEmailNotification"),
          "error"
        );
      }
    },
    deleteDocument,
    deleteMOMDocument,
    ConfirmDelete,
    alertDialog,
    createUUID,
    updateMeeting,
    popupBlockerAlert,
    getUniqueId,
    openMeetingListDrawer,
    openAgendaDialog,
    isPanelExpand,
    onExpandClick,
    onExpandMOMPanelClick,
    isMOMAttendeesPanelOpen,
    signalRTopicVoting,
    signalRTenentConfig,
    getUserVotingData,
    addDeletedUserDetails,
    onMemoDescriptionUpdate,
    trimHtml(html) {
      return html.replace(/[&<>"']/g, (char) => `&#${char.charCodeAt(0)};`);
    },
  },
};

function onMemoDescriptionUpdate(memoComment, topic) {
  let meetTopic = this.meetingObject.topics.find(
    (s) => String(s.Id).toLowerCase() === String(topic.Id).toLowerCase()
  );
  meetTopic.memoDescription = memoComment;
  this.$eventHub.$emit("onMeetingUpdate");
}

async function addDeletedUserDetails() {
  try {
    const objectWithIdExists = (id) =>
      this.userList.some((obj) => obj.id === id);

    const unmatchedObjects = this.attendeesList.filter(
      (obj) => !objectWithIdExists(obj.id)
    );
    const unmatchedIds = unmatchedObjects.map((obj) => obj.id);
    if (unmatchedIds.length) {
      const result = await this.getDeletedUsersList(unmatchedIds);
      if (result.length) {
        this.localUserList = this.localUserList.concat(result);
      }
    }
  } catch (error) {
    console.log(error, "api error");
  }
}

async function getUserVotingData() {
  try {
    if (this.votingRightPermission || this.auditorConsentPermission) {
      const params = {
        meetingId: this.selectedMeeting.id,
        isSilentRequest: this.isSilentRequest
      };
      const response = await this.getUserMeetingVotes(params);
      if (response) {
        this.userVotingData = response;
      }
    }
  } catch (error) {
    console.log(error, "api error");
  }
}

async function signalRTopicVoting(target) {
  this.signalConnection.on(target, async (message) => {
    if (this.votingRightPermission || this.auditorConsentPermission) {
      await this.getUserVotingData();
    }
    const payload = this.isSilentRequest
                      ? { id: this.selectedMeeting.id, isSilentRequest: this.isSilentRequest }
                      : this.selectedMeeting.id;

    const meetingData = await this.getVotesMeetingDetails(payload);
      if(meetingData && meetingData.topics){
        this.setVotingData(meetingData.topics)
      }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function signalRTenentConfig(target) {
  try {
    this.signalConnection.on(target, async (message) => {
      if (message.config_name == "agendanumbering") {
        await this.getTenantConfigList();
      }
    });
    if (
      this.signalConnection.connectionState.toLowerCase() === "disconnected"
    ) {
      this.signalConnection.start().catch();
    }
  } catch (error) {
    console.log(error, "api error");
  }
}

function isMOMAttendeesPanelOpen(index) {
  if (this.momAttendessPanel) {
    return this.momAttendessPanel.includes(index);
  }
}

function onExpandMOMPanelClick(index) {
  if (!this.momAttendessPanel.includes(index)) {
    this.momAttendessPanel.push(index);
  } else {
    this.momAttendessPanel.splice(this.momAttendessPanel.indexOf(index), 1);
  }
}

function onExpandClick(id) {
  if (!this.expandPanel.includes(id)) {
    this.expandPanel.push(id);
  } else {
    this.expandPanel.splice(this.expandPanel.indexOf(id), 1);
  }
}

function isPanelExpand(id) {
  return this.expandPanel.includes(id);
}

function openMeetingListDrawer() {
  this.meetingListDrawer = true;
}

function openAgendaDialog(agendaDetails = null) {
  if (agendaDetails) {
    agendaDetails.category = this.categoriesList.find(
      (c) =>
        String(c.name).toLowerCase() ===
        String(agendaDetails.category).toLowerCase()
    ) || { order: 0, name: "", color: "#2471A3" };
    agendaDetails.meetingType = this.meetingTypesList.find(
      (c) =>
        String(c.label).toLowerCase() ===
        String(agendaDetails.meetingType).toLowerCase()
    ) || { label: "", color: "#F5CBA7" };
    this.editAgenda(agendaDetails);
  } else {
    this.createAgenda();
  }
}
function getUniqueId() {
  return `_${Math.random().toString(36).substr(2, 9)}`;
}

async function updateMeeting() {
  const updatedMeetingObj = await this.getMeetingDetails(this.meetingObject.id);

  updatedMeetingObj.topics = this.meetingObject.topics;

  this.updateMeetingData(updatedMeetingObj).then((response) => {});
}

async function deleteDocument(item, rowData) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    if (item.documentId) {
      for (var i = 0; i < rowData.documents.length; i++) {
        var obj = rowData.documents[i];
        if (item.documentId === obj.documentId) {
          rowData.documents.splice(i, 1);
          i--;
        }
      }
      this.$eventHub.$emit("onMeetingUpdate");
      if (item.action !== "add") {
        this.$eventHub.$emit("onDeleteDocuments", item.documentId);
      }
    }
  }
}

async function deleteMOMDocument(item) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    if (item.documentId) {
      for (var i = 0; i < this.momDocuments.length; i++) {
        var obj = this.momDocuments[i];
        if (item.documentId === obj.documentId) {
          this.momDocuments.splice(i, 1);
          i--;
        }
      }
      this.$eventHub.$emit("onMeetingUpdate");
      if (item.action !== "add") {
        this.$eventHub.$emit("onDeleteDocuments", item.documentId);
      }
    }
  }
}

async function ConfirmDelete() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}

async function popupBlockerAlert() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.lblPopupBlocked"),
      this.$t("agenda.msgPopupBlocked"),
      { noconfirm: true, dialogIcon: "alert" }
    )
  ) {
    return true;
  }
}
async function alertDialog() {
  if (
    await this.$refs.confirm.open(
      this.$t("Alert"),
      this.$t("agenda.CannotDownloadAlert"),
      { noconfirm: true }
    )
  ) {
    return true;
  }
}

function gettersMap() {
  return mapGetters({
    categoriesList: "tenant/agendaCategories",
    meetingTypesList: "tenant/agendaMeetingTypes",
    tenantSettingTypes: "tenant/tenantSettingTypes",
    getMeetingTypeId: "meeting/getMeetingTypeId",
    getTemplateByTemplateTypeId: "tenant/getTemplateByTemplateTypeId",
    getTemplateByTemplateId: "tenant/getTemplateByTemplateId",
  });
}

var downloadMsg = (function () {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";

  return function (data, name) {
    var blob = new Blob(data, {
        type: "application/octet-stream;charset=utf-8",
      }),
      url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = name;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();
</script>

<style scoped>
.padding-0 {
  padding: 0 !important;
}
.boxShadow-none {
  box-shadow: none !important;
}
.edit-time-field /deep/ .v-input__control .v-input__slot {
  background: #f2f2f2 !important;
}
.panel-header /deep/ .v-toolbar__content {
  padding-left: 20px !important;
  padding-right: 20px !important;
  cursor: pointer;
}

.panel-header {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

.element {
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

.element:not(:last-child) {
  margin-bottom: 16px;
}

.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(
    .v-expansion-panel-header__icon--disable-rotate
  )
  .v-icon {
  transform: rotate(0deg) !important;
}

.meeting-action-buttons {
  display: contents;
}

.arrow-up-thick {
  border-radius: 4px 4px 0px 0px !important;
}

.arrow-down-thick {
  border-radius: 0px 0px 4px 4px !important;
}

.arrow-up-thick-left {
  border-radius: 4px 0px 0px 4px !important;
}

.arrow-down-thick-right {
  border-radius: 0px 4px 4px 0px !important;
}

.topic-list-style {
  list-style-type: disc;
  margin-left: 10px;
}

.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}

.disable-box-shadow {
  box-shadow: none !important;
}

.disabled-up-down {
  background-color: #cccccc !important;
  opacity: 0.5 !important;
}
.cursor-default {
  cursor: default !important;
}
.drag-handle {
  cursor: move;
}
</style>